import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_INTERNAL_LINK, CONTENT_TYPE_TEXT, CONTENT_CATEGORY_MODEL} from '../../constants';

export default {
  id: 'MOD_INVIT_CLT',
  title: 'Un modèle d’Invitation client ? ',
  description: '',
  categories: [CONTENT_CATEGORY_MODEL],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'Si vous souhaitez procéder à des invitations clients en masse, veuillez prendre le modèle suivant :'
  },
  {
    type: CONTENT_TYPE_INTERNAL_LINK,
    value: `${pathHelpContentFile}fr/FR_MOD_INVIT_CLT/Contacts Clients.xls.xlsx`,
    label: 'Contacts Clients'
  }]
};
